import classNames from 'classnames';

import React from 'react';

import ListGroup from 'reactstrap/lib/ListGroup';

interface OwnProps {
  className?: string;
  hasErrors?: boolean;
}

type Props = Readonly<React.PropsWithChildren<OwnProps>>;

const RadioList: React.FC<Props> = ({ className, hasErrors, children }) => {
  return (
    <div className={classNames('list-group radio-list-group', className, { 'is-invalid': hasErrors })}>{children}</div>
  );
};

export default React.memo(RadioList);
